import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
export function WhatsIncluded() {
  const includes = ['Reglas claras (sin obsesión)', 'Menú flexible 7 días: 3 opciones por comida + 2 snacks', 'Lista de compras "súper argentino"', 'Prep de 60 minutos (para salvar tu semana)', 'Tabla de sustituciones (si algo te cae mal, no abandonás)', 'Protocolo 24 horas "estoy explotada"', 'Ansiedad + pancita: scripts de 2 minutos', 'Movimiento suave por niveles (10/15/20 min)'];
  return <section className="py-24 px-4 bg-cream" data-id="element-169">
      <div className="max-w-3xl mx-auto" data-id="element-170">
        <FadeIn className="text-center mb-12" data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-serif text-brown mb-4" data-id="element-172">
            Qué incluye
          </h2>
          <p className="text-terracotta font-medium uppercase tracking-wide text-sm" data-id="element-173">
            Descarga inmediata (PDF)
          </p>
        </FadeIn>

        <FadeIn className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-cream-dark mb-12" data-id="element-174">
          <h3 className="text-xl font-serif text-brown mb-6 pb-4 border-b border-cream-dark" data-id="element-175">
            eBook "Plan Pancita Desinflamada"
          </h3>
          <ul className="space-y-4" data-id="element-176">
            {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-177">
                <Check className="w-5 h-5 text-sage mt-0.5 flex-shrink-0" data-id="element-178" />
                <span className="text-brown-light" data-id="element-179">{item}</span>
              </li>)}
          </ul>
        </FadeIn>

        <FadeIn delay={0.2} className="text-center" data-id="element-180">
          <Button withArrow scrollTo="comprar" className="w-full sm:w-auto" data-id="element-181">
            Quiero empezar hoy
          </Button>
        </FadeIn>
      </div>
    </section>;
}